import type { ReactElement } from 'react';
import { toCurrency } from 'utils/numbers';
import Cart from 'models/Cart';
import Alert from '../Alert';

type Props = { cart: Cart; };

function FreeShippingAlert({ cart }: Props): ReactElement {
  return (
    <Alert type={cart?.alert?.type} heapEvent={cart?.alert?.heapEvent}>
      You’re
      <strong>
        {` ${toCurrency(cart.amountAwayFromFreeShipping)} `}
      </strong>
      away from
      <strong>{' FREE '}</strong>
      shipping!
    </Alert>
  );
}

export default FreeShippingAlert;
